module.exports = __webpack_public_path__ + "img/blue-fierce.1044a3da.jpg";